import { render, staticRenderFns } from "./PlatformStatementUpload.vue?vue&type=template&id=49ab203c&scoped=true&"
import script from "./PlatformStatementUpload.vue?vue&type=script&lang=js&"
export * from "./PlatformStatementUpload.vue?vue&type=script&lang=js&"
import style0 from "./PlatformStatementUpload.vue?vue&type=style&index=0&id=49ab203c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ab203c",
  null
  
)

export default component.exports